/*
 * @Author: Matheus Rezende
 * @Date: 2018-04-16 17:00:44
 * @Last Modified by: matheus.rezende
 * @Last Modified time: 2018-11-02 06:52:49
 */

import { AxiosRequestConfig, Method } from 'axios';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { useDispatch } from 'react-redux';
import requestRestfulApi, { dispatchFailure } from './Request.helper';
import { INeoAction } from '../store/Actions.interface';
import { NeoState } from '../store';
import storeConfig from '../Config/store.config';
import { Action } from 'redux';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { extractErrorMessage } from './Error.helper';

export const createAction = (params: INeoAction): INeoAction => params;

interface RequestAction {
  name: string; // reducer that will be affected
  url: string;
  config?: AxiosRequestConfig;
  data?: any;
  args?: any;
  method?: Method;
  apiVersion?: string;
  request?: any;
  setRawDate?: Function;
}

export const createRequestAction = <T>({
  name,
  url,
  config,
  method,
  data,
  apiVersion,
  request,
  setRawDate,
}: RequestAction): ThunkAction<Promise<T>, NeoState, unknown, INeoAction> => async (
  dispatch,
  getState?,
) => {
  const response = await requestRestfulApi<T>({
    actionName: name,
    url,
    config: { ...config, data, method },
    dispatch,
    state: getState?.() || ({} as NeoState),
    apiVersion,
    request,
  });
  setRawDate?.(response);
  if (!response) {
    dispatchFailure(dispatch, name, { message: 'app.default.error' }, request, config);
  } else if (response.status < 200 || response.status >= 300) {
    if (response.status >= 500 && response.status < 600) {
      dispatchFailure(
        dispatch,
        name,
        {
          error: `5XX: url: ${url}, response: ${extractErrorMessage(
            response?.data as IErrorResponse,
          )}`,
        },
        request,
        config,
      );
    } else {
      dispatchFailure(dispatch, name, response?.data as IErrorResponse, request, config);
    }
  }
  return response?.data;
};

export type NeoThunkDispatch = ThunkDispatch<NeoState, unknown, Action<string>>;

export const useThunkDispatch = (): NeoThunkDispatch =>
  useDispatch<typeof storeConfig.store.dispatch>();
